import React, { useState } from 'react';
import { useApp } from '@/context/AppContext';
import { api } from '@/lib/api';

export default function ForceResetModal() {
  const { user, login } = useApp();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword.length < 8) {
      setError('New password must be at least 8 characters long.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      await api.post('/auth/change-password', {
        old_password: oldPassword,
        new_password: newPassword
      });
      // Force refresh user context by relogging them in
      await login(user.email, newPassword);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to change password. Make sure your current password is correct.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-black/95 flex items-center justify-center p-4 backdrop-blur-sm">
      <div className="bg-[#0f0f13] border border-red-500/30 p-8 rounded-xl max-w-md w-full shadow-2xl">
        <h2 className="text-2xl font-bold text-white mb-2">Security Requirement</h2>
        <p className="text-zinc-400 text-sm mb-6">
          Your account is flagged for a mandatory password reset. You must update your password to continue accessing the system securely.
        </p>

        {error && (
          <div className="bg-red-500/10 border border-red-500/50 text-red-500 p-3 rounded mb-6 text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-semibold text-zinc-500 uppercase tracking-wider mb-1">Current Password</label>
            <input
              type="password"
              required
              className="w-full bg-[#1a1a23] border border-[#2a2a35] text-white px-4 py-2 rounded focus:outline-none focus:border-red-500 transition-colors"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
            />
          </div>

          <div>
            <label className="block text-xs font-semibold text-zinc-500 uppercase tracking-wider mb-1">New Password</label>
            <input
              type="password"
              required
              className="w-full bg-[#1a1a23] border border-[#2a2a35] text-white px-4 py-2 rounded focus:outline-none focus:border-red-500 transition-colors"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>

          <div>
            <label className="block text-xs font-semibold text-zinc-500 uppercase tracking-wider mb-1">Confirm New Password</label>
            <input
              type="password"
              required
              className="w-full bg-[#1a1a23] border border-[#2a2a35] text-white px-4 py-2 rounded focus:outline-none focus:border-red-500 transition-colors"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full mt-4 bg-red-600 hover:bg-red-700 text-white font-medium py-2.5 rounded transition-colors disabled:opacity-50"
          >
            {loading ? 'Updating Credentials...' : 'Set New Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
